var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8823 24.6477C13.601 24.929 13.2195 25.0871 12.8217 25.0871C12.4238 25.0871 12.0423 24.929 11.761 24.6477L1.15441 14.0411C0.873106 13.7598 0.715071 13.3783 0.715071 12.9805C0.715071 12.5826 0.873106 12.2011 1.15441 11.9198L11.761 1.31321C12.0423 1.0319 12.4238 0.873867 12.8217 0.873867C13.2195 0.873866 13.601 1.0319 13.8823 1.31321C14.1636 1.59451 14.3217 1.97604 14.3217 2.37387C14.3217 2.77169 14.1636 3.15322 13.8823 3.43453L4.33639 12.9805L13.8823 22.5264C14.1636 22.8077 14.3217 23.1892 14.3217 23.5871C14.3217 23.9849 14.1636 24.3664 13.8823 24.6477Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4907 14.0416C24.3516 14.1811 24.1863 14.2917 24.0042 14.367C23.8222 14.4424 23.6271 14.481 23.4301 14.4807L2.21688 14.4807C1.82147 14.4771 1.44347 14.3176 1.16513 14.0367C0.886785 13.7558 0.730626 13.3764 0.730627 12.981C0.730627 12.5855 0.886786 12.2061 1.16513 11.9252C1.44347 11.6444 1.82147 11.4848 2.21688 11.4812L23.4301 11.4812C23.7267 11.4812 24.0167 11.5692 24.2633 11.734C24.5099 11.8988 24.7021 12.1331 24.8157 12.4071C24.9292 12.6812 24.9589 12.9827 24.9011 13.2736C24.8432 13.5646 24.7004 13.8318 24.4907 14.0416Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.f7062436a85ca4effcccf76dbd9a82f6.svg";
export { ForwardRef as ReactComponent };